import React from 'react'
import Table from './Components/Table'

const DataTables = () => {
  return (
        <div className="content px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
			<h4 className="mb-4">Datatables</h4>
			<p className="lead">react-table is a react library. It is a highly flexible tool, built upon the foundations of progressive enhancement, that adds all of these advanced features to any HTML table. </p>
			<Table/>
		</div>
    )
}

export default DataTables